// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/shape-charts.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/img/background-hero.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/img/background-card.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Component BREADCRUMBS */
.capitalize-first {
    text-transform: lowercase;
}

.capitalize-first::first-letter {
    text-transform: uppercase;
}

.last-breadcrumb {
    width: calc(100% - 32px);
}

/* Component NUMBER CHARTS */
.container-charts {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: relative;
    width: 17.75rem;
    height: 14.875rem;
    display: flex;
    justify-content: center;
}

.number {
    background-color: #49CBBF;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 3.924rem;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    font-weight: 900;
    -webkit-font-smoothing: antialiased;
    line-height: 4.534rem;
}

/* Component DIALOG */
.container-dialog {
    background-color: rgba(0, 0, 0, 0.25);
    z-index: 11162024;
}

.container-inner {
    width: 328px;
    /* height: 234px; */
    border-radius: 28px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* Component NOT DATA MAP */
.container-not-data-map {
    width: 100%;
    height: 100%;
    background: rgb(255, 255, 255, 0.4);
    z-index: 8473;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Componente QUICK ACCESS TO RIGHTS */
.imagen-bg-card-rights,
.dynamic-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    position: absolute;
    background-position: center;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    background-size: cover;
}

/* Componente LOADING */
.loader {
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

/* Componente PREDICTIVE SEARCH */
.search-predictive::placeholder {
    color: #40484C;
}

.search-predictive::-moz-placeholder {
    color: #40484C;
}

.search-predictive::-webkit-input-placeholder {
    color: #40484C;
}

.container-search {
    width: calc(100% - 2rem);
}

/* COMPONENTE TIMELINE */
.timeline {
    height: 104px;
    top: 5px;
    position: relative;
    width: 100%;
    margin: auto;
    display: flex;
    gap: 2.5rem;
    overflow-x: hidden;
    align-items: center;
}

.timeline .middle-line {
    position: absolute;
    width: 100%;
    height: 5px;
    top: 50%;
    transform: translateY(-50%);
    background: #d9d9d9;
    transition: width 0.3s ease;
}

.box {
    position: relative;
    transform: translateY(-25%);
    display: flex;
    flex-direction: column;
    align-items: center;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@media screen and (min-width: 904px) {
    .container-inner {
        width: 386px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,4BAA4B;AAC5B;IACI,yDAAuD;IACvD,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yDAA0D;IAC1D,4BAA4B;IAC5B,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;;IAEI,yDAA0D;IAC1D,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,gCAAgC;IAChC,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA,iCAAiC;AACjC;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* Component BREADCRUMBS */\n.capitalize-first {\n    text-transform: lowercase;\n}\n\n.capitalize-first::first-letter {\n    text-transform: uppercase;\n}\n\n.last-breadcrumb {\n    width: calc(100% - 32px);\n}\n\n/* Component NUMBER CHARTS */\n.container-charts {\n    background-image: url('../assets/img/shape-charts.png');\n    position: relative;\n    width: 17.75rem;\n    height: 14.875rem;\n    display: flex;\n    justify-content: center;\n}\n\n.number {\n    background-color: #49CBBF;\n    background-image: url(\"../assets/img/background-hero.png\");\n    background-repeat: no-repeat;\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-size: 3.924rem;\n    text-align: center;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-weight: 900;\n    -webkit-font-smoothing: antialiased;\n    line-height: 4.534rem;\n}\n\n/* Component DIALOG */\n.container-dialog {\n    background-color: rgba(0, 0, 0, 0.25);\n    z-index: 11162024;\n}\n\n.container-inner {\n    width: 328px;\n    /* height: 234px; */\n    border-radius: 28px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n/* Component NOT DATA MAP */\n.container-not-data-map {\n    width: 100%;\n    height: 100%;\n    background: rgb(255, 255, 255, 0.4);\n    z-index: 8473;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Componente QUICK ACCESS TO RIGHTS */\n.imagen-bg-card-rights,\n.dynamic-banner {\n    background-image: url('../assets/img/background-card.jpg');\n    position: absolute;\n    background-position: center;\n    width: 100%;\n    height: 100%;\n    opacity: 0.1;\n    background-size: cover;\n}\n\n/* Componente LOADING */\n.loader {\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n}\n\n/* Componente PREDICTIVE SEARCH */\n.search-predictive::placeholder {\n    color: #40484C;\n}\n\n.search-predictive::-moz-placeholder {\n    color: #40484C;\n}\n\n.search-predictive::-webkit-input-placeholder {\n    color: #40484C;\n}\n\n.container-search {\n    width: calc(100% - 2rem);\n}\n\n/* COMPONENTE TIMELINE */\n.timeline {\n    height: 104px;\n    top: 5px;\n    position: relative;\n    width: 100%;\n    margin: auto;\n    display: flex;\n    gap: 2.5rem;\n    overflow-x: hidden;\n    align-items: center;\n}\n\n.timeline .middle-line {\n    position: absolute;\n    width: 100%;\n    height: 5px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: #d9d9d9;\n    transition: width 0.3s ease;\n}\n\n.box {\n    position: relative;\n    transform: translateY(-25%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@media screen and (min-width: 904px) {\n    .container-inner {\n        width: 386px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
